import React from "react";
import { Link } from "react-router-dom";

const LOGO_COLOR = "https://customer-assets.emergentagent.com/job_worldly-consulting/artifacts/ci1qultx_worldly-solutions-high-resolution-logo-color-on-transparent-background.svg";
const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_worldly-consulting/artifacts/x0h6n79n_worldly-solutions-high-resolution-logo-white-on-transparent-background.svg";

export const Logo = ({ size = "md", variant = "dark" }) => {
  const heights = {
    sm: "h-10",
    md: "h-14",
    lg: "h-20",
  };
  const isLight = variant === "light";
  const src = isLight ? LOGO_WHITE : LOGO_COLOR;

  return (
    <Link to="/" data-testid="logo-link" className="inline-flex items-center gap-3 group">
      <img
        src={src}
        alt="Worldly Solutions — Think Build Manage"
        className={`${heights[size]} w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]`}
      />
    </Link>
  );
};

export default Logo;
